<template>
  <div id="personal-index">
    <!-- 个人中心 -->
    <div class="content">
      <div class="title">
        <div class="hx"></div>
        <div class="tt">修改密码</div>
      </div>
      <div class="line">
        <div class="title">原密码:</div>
        <div class="value">
          <el-input
            v-model="old"
            clearable
            show-password
            placeholder="请输入原密码"
          ></el-input>
        </div>
      </div>
      <div class="line">
        <div class="title">新密码:</div>
        <div class="value">
          <el-input
            v-model="newPwd"
            clearable
            show-password
            placeholder="请输入新密码"
          ></el-input>
        </div>
      </div>
      <div class="line">
        <div class="title">再次输入密码:</div>
        <div class="value">
          <el-input
            v-model="newAgainPwd"
            clearable
            show-password
            placeholder="请再次输入新密码"
          ></el-input>
        </div>
      </div>
      <div class="line"></div>
      <div class="line">
        <div class="title"></div>
        <div class="add_but" @click="editPwd">
          <i class="el-icon-check"></i>确认
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      old: "", // 原密码
      newPwd: "", // 新密码
      newAgainPwd: "", //再次输入新密码
    };
  },
  methods: {
    async editPwd() {
      try {
        if (this.old == "") {
          throw { message: "原密码不可为空!" };
        }
        if (this.newPwd == "") {
          throw { message: "新密码不可为空!" };
        }
        if (this.newAgainPwd == "") {
          throw { message: "两次密码不一致!" };
        }
        if (this.newAgainPwd != this.newPwd) {
          throw { message: "两次密码不一致!" };
        }
        let requestData = {
          id: JSON.parse(sessionStorage.getItem("userData")).userId,
          newPwd: this.newPwd,
          old: this.old,
        };
        let resultData = await this.$request({
          url: "/exam/reExamList",
          method: "post",
          data: requestData,
        });
        this.old = "";
        this.newPwd = "";
        this.newAgainPwd = "";
        this.$message.error("密码修改成功,请重新登录!");
        sessionStorage.clear();
        this.$router.push("/");
      } catch (error) {
        this.$message.error(error.message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
#personal-index {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  > .content {
    width: 40%;
    height: auto;
    background-color: #fcfcfc;
    display: flex;
    flex-direction: column;

    > .title {
      width: 100%;
      height: 40px;
      display: flex;
      padding: 0 20px;
      box-sizing: border-box;
      margin-top: 10px;
      > .hx {
        width: 3px;
        height: 18px;
        background-color: #02386e;
        margin-right: 8px;
        margin-top: 2px;
      }
      > .tt {
        font-size: 15px;
        font-weight: bold;
      }
    }

    > .line {
      width: 100%;
      height: 45px;
      display: flex;
      align-items: center;
      > .title {
        width: 180px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 10px;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: bold;
      }
      > .value {
        width: 0;
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-right: 30px;
        box-sizing: border-box;
      }
    }
  }
}
</style>